// extracted by mini-css-extract-plugin
export default {"page":"CommunitySso_page__83CGp"};